import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class UuserService extends Service{
    constructor() {
        super();
        this.baseURL = 'uUser';
    }

    changePassword(data) {
        return fetch(SERVER_URL + this.baseURL+ '/changePassword', {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addUpdateInfo(data))
        }).then(response => {
                let result = response.clone();
                GeneralUtils.notification(response);
                return result.json();
            }
        ).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}